import { ThemeEvents } from '@theme/events';

/**
 * <plw-pdp-media> — the PDP buy-box inset image (blocks/_plw-pdp-title.liquid).
 *
 * The inset shows the selected colorway's flat shot (variant metafield
 * custom.flat_image, falling back to the variant's featured media). It lives
 * in a static block that nothing morphs on variant change, so — like Horizon's
 * media-gallery.js — this element replaces itself with its counterpart from
 * the full-document fetch the variant picker performs. The wrapper renders
 * unconditionally (even imageless) so the swap works in both directions.
 */
class PlwPdpMedia extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    const target = this.closest('.shopify-section, dialog');

    target?.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate, {
      signal: this.#controller.signal,
    });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  /**
   * Replaces this element with the freshly rendered one for the new variant.
   *
   * @param {import('@theme/events').VariantUpdateEvent} event - The variant update event.
   */
  #handleVariantUpdate = (event) => {
    const source = event.detail.data.html;

    if (!source) return;
    const next = source.querySelector('plw-pdp-media');

    if (!next) return;

    this.replaceWith(next);
  };
}

if (!customElements.get('plw-pdp-media')) {
  customElements.define('plw-pdp-media', PlwPdpMedia);
}
